import { render, staticRenderFns } from "./ProductDetailsModal.vue?vue&type=template&id=537c6d4e&"
import script from "./ProductDetailsModal.vue?vue&type=script&lang=js&"
export * from "./ProductDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports